import { useQuery } from '@tanstack/react-query'

/** 各工作流节点待办计数(键见后端 get_task_badges.py / 菜单 taskBadge) */
export type TaskBadges = Record<string, number>

/**
 * 拉取当前用户「所有角色」并集的各待办节点计数,供侧边菜单角标。
 * 实时性主要靠 SSE(方案A):待办变化时后端广播 `badges` → NotificationProvider
 * invalidate 本查询立即重拉;此处的轮询仅作 5 分钟兜底(防 SSE 断连期间漂移)。
 * 刷新失败保留上次数据，由工作台展示重试提示。
 */
export function useTaskBadges() {
  return useQuery<TaskBadges>({
    queryKey: ['task-badges'],
    queryFn: async () => {
      const res = await fetch('/api/v1/dashboard/task-badges', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      })
      if (!res.ok) throw new Error('任务数量加载失败，请刷新重试')
      const json = await res.json()
      return (json.result as TaskBadges) || {}
    },
    staleTime: 30_000,
    refetchInterval: 300_000, // SSE 实时驱动,轮询降为 5min 兜底
    refetchOnWindowFocus: true,
  })
}
